import React from 'react'
import './DashboardItem.scss'
import { InfoBox } from '../InfoBox'
import { Info } from '../InfoBox/InfoBox'

interface IProps {
  title: string
  rows: Info[]
  titleIcon?: string
}

export function DashboardItem({ rows, title, titleIcon }: IProps) {
  return (
    <div className="dashboard-item">
      <div className="dashboard-item__title">
        {titleIcon && <img className="dashboard-item__title-icon" alt="icon" src={titleIcon} />}
        <p className="dashboard-item__title-text">{title}</p>
      </div>
      <InfoBox infos={rows} />
    </div>
  )
}
